import {
  ComponentConfig,
  ComponentType,
  DrawerMenuConfig,
  LayoutTypes,
  ScreenGroupComponent,
  SummaryListActionConfig,
  SummaryListComponent,
} from "../../services/types/ComponentTypes";
import { apiService } from "../../services/api";
import { authService } from "../../services/auth";
import { screen_100_home } from "../../config/100_home";
import { screen_2217_emp_profile } from "../../config/2217_emp_profile";
import { screen_101_vehicles } from "../../config/101_vehicles";
import { screen_102_add_vehicle } from "../../config/102_add_vehicle";
import { screen_103_inspection } from "../../config/103_inspection";
import { screen_104_job_card } from "../../config/104_job_card";
import { screen_105_products } from "../../config/105_products";
import { screen_106_add_product } from "../../config/106_add_product";
import { screen_107_add_inspection } from "../../config/107_add_inspection";
import { screen_108_employee } from "../../config/108_employee";
import { screen_109_parts_request } from "../../config/109_parts_request";
import { screen_110_employee_group } from "../../config/110_employee_group";
import { screen_111_labour_others } from "../../config/111_labour_others";
import { screen_112_stock } from "../../config/112_stock";
import { screen_113_parts_issue } from "../../config/113_parts_issue";
import { screen_114_customers } from "../../config/114_customers";
import { screen_115_parts_return } from "../../config/115_parts_return";
import { screen_116_add_estimate } from "../../config/116_add_estimate";
import { screen_117_invoices } from "../../config/117_invoices";
import { screen_118_sales_return_voucher } from "../../config/118_sales_return_voucher";
import { screen_119_add_labour_others } from "../../config/119_add_labour_others";
import { screen_120_add_parts_issue } from "../../config/120_add_parts_issue";
import { screen_121_add_parts_return } from "../../config/121_add_parts_return";
import { screen_122_add_employee } from "../../config/122_add_employee";
import { screen_123_add_customer } from "../../config/123_add_customer";
import { screen_124_add_sales_return_voucher } from "../../config/124_add_sales_return_voucher";
import { screen_125_purchase_return_voucher } from "../../config/125_purchase_return_voucher";
import { screen_126_add_purchase_return_voucher } from "../../config/126_add_purchase_return_voucher";
import { screen_127_vendors } from "../../config/127_vendors";
import { screen_128_add_vendor } from "../../config/128_add_vendor";
import { screen_129_purchase_order } from "../../config/129_purchase_order";
import { screen_130_add_purchase_order } from "../../config/130_add_purchase_order";
import { screen_131_cash_and_bank } from "../../config/131_cash_and_bank";
import { screen_24_account_flow } from "../../config/24_account_flow";
import { screen_132_charts_of_accounts } from "../../config/132_charts_of_accounts";
import { screen_133_heads_balance_add_for_chart_of_accounts_head } from "../../config/133_heads_balance_add_for_chart_of_accounts_head";
import { screen_134_account_heads } from "../../config/134_account_heads";
import { screen_135_heads_add } from "../../config/135_heads_add";
import { screen_136_head_name } from "../../config/136_head_name";
import { screen_137_head_name_add } from "../../config/137_head_name_add";
import { screen_138_purchase } from "../../config/138_purchase";
import { screen_139_add_purchase } from "../../config/139_add_purchase";
import { screen_140_add_purchase_with_order } from "../../config/140_add_purchase_with_order";
import { screen_141_purchase_return } from "../../config/141_purchase_return";
import { screen_142_receipt_summary } from "../../config/142_receipt_summary";
import { screen_143_payments } from "../../config/143_payments";
import { screen_144_add_payment } from "../../config/144_add_payment";
import { screen_145_payment_summary } from "../../config/145_payment_summary";
import { screen_146_manual_journals } from "../../config/146_manual_journals";
import { screen_147_contra_vouchers } from "../../config/147_contra_vouchers";
import { screen_148_petty_cash_vouchers } from "../../config/148_petty_cash_vouchers";
import { screen_149_cash_payment_vouchers } from "../../config/149_cash_payment_vouchers";
import { screen_150_estimate_approval } from "../../config/150_estimate_approval";
import { screen_27_accounting_years } from "../../config/27_accounting_years";
import { screen_28_accounting_year_mapper } from "../../config/28_accounting_year_mapper";
import { screen_34_ledger_carry_forward } from "../../config/34_ledger_carry_forward";
import { screen_29_journal_voucher } from "../../config/29_journal_voucher";
import { screen_30_receipt_vouchers } from "../../config/30_receipt_vouchers";
import { screen_31_contra_voucher } from "../../config/31_contra_voucher";
import { screen_32_petty_cash_voucher } from "../../config/32_petty_cash_voucher";
import { screen_33_cash_payment_voucher } from "../../config/33_cash_payment_voucher";
import { screen_10_invoice_receivables } from "../../config/10_invoice_receivables";
import { screen_151_vehicle_make } from "../../config/151_vehicle_make";
import { screen_152_vehicle_type } from "../../config/152_vehicle_type";
import { screen_153_lookup_summary } from "../../config/153_lookup_summary";
import { screen_154_branch_summary } from "../../config/154_branch_summary";
import { screen_155_report_summary } from "../../config/155_report_summary";
import { screen_156_jobcard_add } from "../../config/156_jobcard_add";
import { screen_157_qc_approve } from "../../config/157_qc_approve";
import { screen_158_create_invoice } from "../../config/158_create_invoice";
import { screen_159_close_jobcard } from "../../config/159_close_jobcard";
import { screen_160_add_parts_request } from "../../config/160_add_parts_request";
import { screen_161_bank_payment_summary } from "../../config/161_bank_payment_summary";
import { screen_162_bank_payment_voucher } from "../../config/162_bank_payment_voucher";
import { screen_163_credit_note_summary } from "../../config/163_credit_note_summary";
import { screen_164_debit_note_summary } from "../../config/164_debit_note_summary";
import { screen_165_credit_note } from "../../config/165_credit_note";
import { screen_166_debit_note } from "../../config/166_debit_note";
import { screen_167_reports } from "../../config/167_reports";
import { screen_153_lookup_add } from "../../config/153_lookup_add";
import { screen_39_close_jobcard } from "../../config/39_close_jobcard";
import { screen_020_emp_grp_add } from "../../config/020_emp_grp_add";
import { screen_168_sales_person } from "../../config/168_sales_person";
import { screen_019_sales_person_add } from "../../config/019_sales_person_add";
import { screen_169_users_summary } from "../../config/169_users_summary";
import { screen_42_users_add } from "../../config/42_users_add";
import { screen_170_branch_add } from "../../config/170_branch_add";
import { screen_171_stock_movement } from "../../config/171_stock_movement";
import { screen_172_batch_summary } from "../../config/172_batch_summary";
import { screen_173_invoice_add_from_summary } from "../../config/173_invoice_add_from_summary";
import { screen_174_proforma_invoice_summary } from "../../config/174_proforma_invoice_summary";
import { screen_175_proforma_invoice_add } from "../../config/175_proforma_invoice_add";

import { hrmAttendanceConfig as screen_2200_attendance_summary } from "../../config/2200_attendance_summary";
import { screen_2201_leave_management_summary } from "../../config/2201_leave_management_summary";
import { screen_2202_leave_add } from "../../config/2202_leave_add";
import { screen_2299_leave_approve_drawer } from "../../config/2299_leave_approve_drawer";
import { screen_2231_payroll_summary } from "../../config/2231_payroll_summary";
import { screen_176_gate_pass_issue } from "../../config/176_gate_pass_issue";
import { screen_177_vat_journal_summary } from "../../config/177_vat_journal_summary";
import { screen_178_vat_journal_add } from "../../config/178_vat_journal_add";
import { screen_2203_emp_summary } from "../../config/2203_emp_summary";
import { screen_2206_emp_grp_summary } from "../../config/2206_emp_grp_summary";
import { screen_2207_emp_grp_add } from "../../config/2207_emp_grp_add";
import { screen_2208_attendance_sessions } from "../../config/2208_attendance_sessions";
import { screen_2226_time_shift_summary } from "../../config/2226_time_shift_summary";
import { screen_2218_holiday_calendar_summary } from "../../config/2218_holiday_calendar_summary";
import { screen_2227_time_shift_add } from "../../config/2227_time_shift_add";
import { screen_2219_holiday_calendar_add } from "../../config/2219_holiday_calendar_add";
import { screen_2220_holiday_calendar_details } from "../../config/2220_holiday_calendar_details";
import { screen_2205_emp_profile_add } from "../../config/2205_emp_profile_add";
import { screen_2224_holiday_add } from "../../config/2224_holiday_add";
import { screen_2225_weekly_off_add } from "../../config/2225_weekly_off_add";
import { screen_2221_holiday_list } from "../../config/2221_holiday_list";
import { screen_2222_holiday_weekly_off } from "../../config/2222_holiday_weekly_off";

export const screenConfigRegistry: Record<string, ComponentConfig[]> = {
  "100": screen_100_home,
  "2203": screen_2203_emp_summary,
  "2217": screen_2217_emp_profile,
  "2200": screen_2200_attendance_summary,
  "2208": screen_2208_attendance_sessions,
  "2201": screen_2201_leave_management_summary,
  "2202": screen_2202_leave_add,
  "2212": screen_2299_leave_approve_drawer,
  "2231": screen_2231_payroll_summary,
  "176": screen_176_gate_pass_issue,
  "177": screen_177_vat_journal_summary,
  "178": screen_178_vat_journal_add,
  "101": screen_101_vehicles,
  "102": screen_102_add_vehicle,
  "103": screen_103_inspection,
  "104": screen_104_job_card,
  "105": screen_105_products,
  "106": screen_106_add_product,
  "107": screen_107_add_inspection,
  "108": screen_108_employee,
  "109": screen_109_parts_request,
  "110": screen_110_employee_group,
  "111": screen_111_labour_others,
  "112": screen_112_stock,
  "113": screen_113_parts_issue,
  "114": screen_114_customers,
  "115": screen_115_parts_return,
  "116": screen_116_add_estimate,
  "117": screen_117_invoices,
  "118": screen_118_sales_return_voucher,
  "119": screen_119_add_labour_others,
  "120": screen_120_add_parts_issue,
  "121": screen_121_add_parts_return,
  "122": screen_122_add_employee,
  "123": screen_123_add_customer,
  "124": screen_124_add_sales_return_voucher,
  "125": screen_125_purchase_return_voucher,
  "126": screen_126_add_purchase_return_voucher,
  "127": screen_127_vendors,
  "128": screen_128_add_vendor,
  "24": screen_24_account_flow,
  "129": screen_129_purchase_order,
  "130": screen_130_add_purchase_order,
  "131": screen_131_cash_and_bank,
  "132": screen_132_charts_of_accounts,
  "133": screen_133_heads_balance_add_for_chart_of_accounts_head,
  "134": screen_134_account_heads,
  "135": screen_135_heads_add,
  "136": screen_136_head_name,
  "137": screen_137_head_name_add,
  "138": screen_138_purchase,
  "139": screen_139_add_purchase,
  "140": screen_140_add_purchase_with_order,
  "141": screen_141_purchase_return,
  "142": screen_142_receipt_summary,
  "143": screen_143_payments,
  "144": screen_144_add_payment,
  "145": screen_145_payment_summary,
  "146": screen_146_manual_journals,
  "147": screen_147_contra_vouchers,
  "148": screen_148_petty_cash_vouchers,
  "149": screen_149_cash_payment_vouchers,
  "150": screen_150_estimate_approval,
  "10": screen_10_invoice_receivables,
  "27": screen_27_accounting_years,
  "28": screen_28_accounting_year_mapper,
  "29": screen_29_journal_voucher,
  "34": screen_34_ledger_carry_forward,
  "30": screen_30_receipt_vouchers,
  "31": screen_31_contra_voucher,
  "32": screen_32_petty_cash_voucher,
  "33": screen_33_cash_payment_voucher,
  "151": screen_151_vehicle_make,
  "152": screen_152_vehicle_type,
  "153": screen_153_lookup_summary,
  "154": screen_154_branch_summary,
  "155": screen_155_report_summary,
  "156": screen_156_jobcard_add,
  "157": screen_157_qc_approve,
  "158": screen_158_create_invoice,
  "39": screen_39_close_jobcard,
  "159": screen_159_close_jobcard,
  "160": screen_160_add_parts_request,
  "161": screen_161_bank_payment_summary,
  "162": screen_162_bank_payment_voucher,
  "163": screen_163_credit_note_summary,
  "164": screen_164_debit_note_summary,
  "165": screen_165_credit_note,
  "166": screen_166_debit_note,
  "167": screen_167_reports,
  "153_add": screen_153_lookup_add,
  "20": screen_020_emp_grp_add,
  "168": screen_168_sales_person,
  "19": screen_019_sales_person_add,
  "169": screen_169_users_summary,
  "42": screen_42_users_add,
  "170": screen_170_branch_add,
  "171": screen_171_stock_movement,
  "172": screen_172_batch_summary,
  "173": screen_173_invoice_add_from_summary,
  "174": screen_174_proforma_invoice_summary,
  "175": screen_175_proforma_invoice_add,
  "2206": screen_2206_emp_grp_summary,
  "2207": screen_2207_emp_grp_add,
  "2226": screen_2226_time_shift_summary,
  "2218": screen_2218_holiday_calendar_summary,
  "2227": screen_2227_time_shift_add,
  "2219": screen_2219_holiday_calendar_add,
  "2220": screen_2220_holiday_calendar_details,
  "2205": screen_2205_emp_profile_add,
  "2224": screen_2224_holiday_add,
  "2225": screen_2225_weekly_off_add,
  "2221": screen_2221_holiday_list,
  "2222": screen_2222_holiday_weekly_off,
};

export type ConfigSource = 'API' | 'LOCAL' | null;

export interface CachedConfig {
    config: ComponentConfig[];
    source: ConfigSource;
}

// Simple in-memory cache to avoid redundant network requests during the session
export const configCache: Record<string, CachedConfig> = {};

/**
 * Returns the resolved screen config for a given screenId.
 * Checks the API-loaded cache first, then falls back to the local screenConfigRegistry.
 * This ensures that save logic and other runtime operations use the same config
 * that was used to render the UI.
 */
export const getResolvedScreenConfig = (screenId: string): ComponentConfig[] | undefined => {
    return configCache[screenId]?.config || screenConfigRegistry[screenId];
};

export const viewToScreenIdMap: Record<string, string> = {
  garage: "100",
  vehicle_form: "100",
  vehicles: "101",
  inspection: "103",
  job_card: "104",
  products: "105",
  product: "105",
  product_summary: "105",
  product_add: "106",
  "modulev1/product_add": "106",
  "modulev1/product_add/<id>": "106",
  employee: "108",
  employee_group: "110",
  stock: "112",
  stock_movement: "171",
  batch_summary: "172",
  parts_issue: "113",
  parts_request: "109",
  parts_return: "115",
  customers: "114",
  labour_others: "111",
  invoices: "117",
  sales_return_voucher: "118",
  sales_return_vouchers: "118",
  parts_issue_add: "120",
  parts_issue_add_edit: "120",
  parts_return_add: "121",
  parts_return_add_edit: "121",
  emp_add: "122",
  emp_add_edit: "122",
  customer_add: "123",
  customer_add_edit: "123",
  sales_return_voucher_add: "124",
  sales_return_voucher_add_edit: "124",
  "modulev1/sales_return_add": "124",
  "modulev1/sales_return_add/<id>": "124",
  sales_return_add: "124",
  sales_return_summary: "118",
  "modulev1/sales_return_summary": "118",
  purchase_return_voucher: "125",
  purchase_return_vouchers: "125",
  purchase_return_voucher_add: "126",
  purchase_return_voucher_add_edit: "126",
  vendors: "127",
  supplier_summary: "127",
  vendor_summary: "127",
  supplier_add: "128",
  supplier_add_edit: "128",
  vendor_add: "128",
  vendor_add_edit: "128",
  purchase_order: "129",
  purchase_orders: "129",
  purchase_order_summary: "129",
  purchase_order_add: "130",
  purchase_order_add_edit: "130",
  cash_and_bank: "131",
  cash_bank: "131",
  accounts_cash_bank: "131",
  account_flow: "24",
  heads_balance_add: "24",
  "modulev1/heads_balance_add": "24",
  "modulev1/ledgers": "131",
  charts_of_accounts: "132",
  "modulev1/charts_of_accounts": "132",
  "modulev1/heads_balance_add_for_chart_of_accounts_head": "133",
  account_heads: "134",
  heads: "134",
  "modulev1/account_heads": "134",
  "modulev1/heads": "134",
  "modulev1/heads_summary": "134",
  heads_add: "135",
  "modulev1/heads_add": "135",
  "modulev1/sub_group_summary": "136",
  sub_group_summary: "136",
  head_name: "136",
  "modulev1/head_name": "136",
  "modulev1/heads_sub_group_add": "137",
  heads_sub_group_add: "137",
  head_name_add: "137",
  "modulev1/accounting_years_summary": "27",
  accounting_years_summary: "27",
  "modulev1/accounting_year_mapper": "28",
  accounting_year_mapper: "28",
  "modulev1/accounting_year_mapper_summary": "27",
  accounting_year_mapper_summary: "27",
  "modulev1/ledger_carry_forward": "34",
  ledger_carry_forward: "34",
  "modulev1/receivables_summary": "30",
  receivables_summary: "30",
  receipt_vouchers: "30",
  "modulev1/invoice_receivables": "10",
  invoice_receivables: "10",
  "modulev1/purchase_summary": "138",
  purchase_summary: "138",
  "modulev1/purchase_add_without_order": "139",
  purchase_add_without_order: "139",
  "modulev1/purchase_add": "140",
  purchase_add: "140",
  "modulev1/purchase_return_summary": "141",
  purchase_return_summary: "141",
  "modulev1/receipt_summary": "142",
  receipt_summary: "142",
  credit_summary: "142",
  "modulev1/payment_summary": "145",
  payment_summary: "145",
  payments: "143",
  "modulev1/payment_add": "144",
  payment_add: "144",
  "modulev1/payments_summary": "145",
  payments_summary: "145",
  "modulev1/manual_journals": "146",
  manual_journals: "146",
  journal_voucher_summary: "146",
  "modulev1/journal_voucher": "29",
  journal_voucher: "29",
  "modulev1/vat_journal": "178",
  "modulev1/vat_journal/<id>": "178",
  vat_journal: "178",
  vat_journal_summary: "177",
  "modulev1/vat_journal_summary": "177",
  "modulev1/contra_vouchers": "147",
  "modulev1/contra_voucher_summary": "147",
  contra_vouchers: "147",
  contra_voucher_summary: "147",
  "modulev1/contra_voucher": "31",
  "modulev1/contra_voucher/<id>": "31",
  contra_voucher: "31",
  "modulev1/petty_cash_vouchers": "148",
  petty_cash_vouchers: "148",
  petty_cash_voucher_summary: "148",
  "modulev1/petty_voucher_summary": "148",
  "modulev1/petty_cash_voucher": "32",
  "modulev1/petty_cash_voucher/<id>": "32",
  petty_cash_voucher: "32",
  "modulev1/cash_payment_vouchers": "149",
  cash_payment_vouchers: "149",
  cash_payment_voucher_summary: "149",
  "modulev1/cash_payment_voucher_summary": "149",
  "modulev1/cash_payment_voucher": "33",
  "modulev1/cash_payment_voucher/<id>": "33",
  cash_payment_voucher: "33",
  "modulev1/bank_payment_voucher_summary": "161",
  "modulev1/bank_payment_vouchers": "161",
  bank_payment_voucher_summary: "161",
  bank_payment_vouchers: "161",
  bank_payment_summary: "161",
  vehicle_make: "151",
  "modulev1/vehiclemake": "151",
  "screen/vehiclemake": "151",
  vehicle_type: "152",
  "modulev1/vehicletype": "152",
  "screen/vehicletype": "152",
  lookup_summary: "153",
  "modulev1/lookup_summary": "153",
  branch_summary: "154",
  "modulev1/branch_summary": "154",
  report_summary: "155",
  "modulev1/report_summary": "155",
  jobcard_add: "156",
  "modulev1/jobcard_add": "156",
  "modulev1/jobcard_add/<id>": "156",
  "modulev1/qc_approve": "157",
  "modulev1/qc_approve/<id>": "157",
  invoice_add: "158",
  "modulev1/invoice_add": "158",
  "modulev1/invoice_add/<id>": "158",
  "modulev1/parts_request_add": "160",
  "modulev1/parts_request_add/<id>": "160",
  "modulev1/close_jobcard": "39",
  "modulev1/close_jobcard/<id>": "39",
  "modulev1/bank_payment_voucher": "162",
  "modulev1/bank_payment_voucher/<id>": "162",
  "modulev1/credit_note_summary": "163",
  credit_note_summary: "163",
  "credit-note-summary": "163",
  "vouchers/credit-note-summary": "163",
  "modulev1/debit_note_summary": "164",
  debit_note_summary: "164",
  "debit-note-summary": "164",
  "vouchers/debit-note-summary": "164",
  "modulev1/credit_note": "165",
  "modulev1/credit_note/<id>": "165",
  credit_note: "165",
  "modulev1/debit_note": "166",
  "modulev1/debit_note/<id>": "166",
  debit_note: "166",
  // Reports
  reports: "167",
  "modulev1/reports": "167",
  "modulev1/ReportModule": "167",
  report_module: "167",
  lookup_add: "153_add",
  "modulev1/lookup_add/<id>": "153_add",
  "modulev1/emp_grp_add": "20",
  "modulev1/emp_grp_add/<id>": "20",
  emp_grp_add: "20",
  emp_grp_summary: "110",
  "modulev1/emp_grp_summary": "110",
  "modulev1/sales_person_summary": "168",
  "modulev1/sales_person_add": "19",
  "modulev1/sales_person_add/<id>": "19",
  "user_summary": "169",
  "modulev1/user_summary": "169",
  "modulev1/users_add": "42",
  "modulev1/users_add/<id>": "42",
  "modulev1/branch_add": "170",
  branch_add: "170",
  "modulev1/invoice_add_from_summary": "173",
  invoice_add_from_summary: "173",
  "modulev1/proforma_invoice_summary": "174",
  proforma_invoice_summary: "174",
  "modulev1/proforma_invoice_add": "175",
  proforma_invoice_add: "175",
  "modulev1/proforma_invoice_add/<id>": "175",
  leave_management: "2201",
  // HRMS Leave screens (API configs commonly use these view/action ids)
  leave_management_summary: "2201",
  leave_add: "2202",
  leave_approve_reject: "2212",
  payroll_summary: "2231",
  "modulev1/gate_pass_issue": "176",
  "time_shift_summary": "2226",
  "modulev1/time_shift_summary": "2226",
  "holiday_calendar_summary": "2218",
  "modulev1/holiday_calendar_summary": "2218",
  "time_shift_add": "2227",
  "modulev1/time_shift_add": "2227",
  "modulev1/time_shift_add/<id>": "2227",
  "holiday_calendar_add": "2219",
  "modulev1/holiday_calendar_add": "2219",
  "modulev1/holiday_calendar_add/<id>": "2219",
  "holiday_calendar_details": "2220",
  "modulev1/holiday_calendar_details": "2220",
  "modulev1/holiday_calendar_details/<id>": "2220",
  "hrm/holiday_calendar_details": "2220",
  "hrm/holiday_calendar_details/<id>": "2220",
  "emp_profile_add": "2205",
  "emp_profile_add/<id>": "2205",
  "modulev1/emp_profile_add": "2205",
  "modulev1/emp_profile_add/<id>": "2205",
  "hrm/employee_edit": "2205",
  "hrm/employee_edit/<id>": "2205",
  "hrm/emp_grp_add": "2207",
  "hrm/emp_grp_add/<id>": "2207",
  "holiday_add": "2224",
  "modulev1/holiday_add": "2224",
  "modulev1/holiday_add/<id>": "2224",
  "hrm/holiday_add": "2224",
  "hrm/holiday_add/<id>": "2224",
  "weekly_off_add": "2225",
  "modulev1/weekly_off_add": "2225",
  "modulev1/weekly_off_add/<id>": "2225",
  "hrm/weekly_off_add": "2225",
  "hrm/weekly_off_add/<id>": "2225",
  "holiday_list": "2221",
  "modulev1/holiday_list": "2221",
  "hrm/holiday_list": "2221",
  "holiday_weekly_off": "2222",
  "modulev1/holiday_weekly_off": "2222",
  "hrm/holiday_weekly_off": "2222",
  "hrm/holiday_calendar_add": "2219",
  "hrm/holiday_calendar_add/<id>": "2219",
};

/** Normalize a view string to the API name used for GET /pabws/screen/{name} */
const normalizeViewToScreenApiName = (view: string): string =>
  view
    .replace(/^modulev1\//, "")
    .replace(/\/<id>.*$/, "")
    .replace(/\/<id>/, "")
    .split("/")[0] || view;

/**
 * Map screenId -> canonical API name for GET /pabws/screen/{name}.
 * Built from viewToScreenIdMap; prefers view names containing "summary" or "_add".
 */
export const screenIdToScreenApiName: Record<string, string> = (() => {
  const byScreenId: Record<string, string[]> = {};
  for (const [view, screenId] of Object.entries(viewToScreenIdMap)) {
    if (!byScreenId[screenId]) byScreenId[screenId] = [];
    byScreenId[screenId].push(view);
  }
  const map: Record<string, string> = {};
  for (const [screenId, views] of Object.entries(byScreenId)) {
    const preferred = views.find(
      (v) =>
        v.includes("summary") ||
        v.includes("_add") ||
        v.includes("_summary")
    );
    const view = preferred ?? views[0];
    map[screenId] = normalizeViewToScreenApiName(view);
  }
  return map;
})();

/**
 * Returns the API name to use for the screen-load call GET /pabws/screen/{name}.
 * 1. SCREEN_GROUP.loadApiName if set in config
 * 2. currentView normalized (if not purely numeric)
 * 3. screenIdToScreenApiName[screenId]
 */
export const getScreenApiName = (
  screenId: string,
  config?: ComponentConfig[],
  currentView?: string
): string | undefined => {
  const screenGroup = config?.find(
    (c) => c.componentType === LayoutTypes.SCREEN_GROUP
  ) as ScreenGroupComponent | undefined;
  if (screenGroup?.loadApiName) {
    return screenGroup.loadApiName;
  }
  if (currentView && currentView.trim() && !/^\d+$/.test(currentView.trim())) {
    return normalizeViewToScreenApiName(currentView);
  }
  return screenIdToScreenApiName[screenId];
};

const inputComponentTypes: ComponentType[] = [
  ComponentType.TEXT_FIELD,
  ComponentType.TEXT_AREA,
  ComponentType.SELECT_DROPDOWN,
  ComponentType.SEARCHABLE_DROPDOWN,
  ComponentType.RADIO_FIELD,
  ComponentType.DATE_FIELD,
  ComponentType.IMAGE_UPLOAD,
  ComponentType.MULTI_CHECKBOX,
];

export const walkComponentTree = (
  components: ComponentConfig[] | undefined,
  visitor: (component: ComponentConfig) => boolean | void
) => {
  if (!components) {
    return;
  }

  for (const component of components) {
    const shouldStop = visitor(component);
    if (shouldStop) {
      return;
    }

    const childComponents = (component as any).childComponents as
      | ComponentConfig[]
      | undefined;
    if (childComponents && childComponents.length > 0) {
      walkComponentTree(childComponents, visitor);
    }

    const childControls = (component as any).childControls as
      | ComponentConfig[]
      | undefined;
    if (childControls && childControls.length > 0) {
      walkComponentTree(childControls, visitor);
    }

    // Also traverse Fields property (used by FORM components)
    const fields = (component as any).Fields as
      | ComponentConfig[]
      | undefined;
    if (fields && fields.length > 0) {
      walkComponentTree(fields, visitor);
    }
  }
};

export const findSummaryListByAction = (
  targetAction: SummaryListActionConfig
): SummaryListComponent | null => {
  for (const screenId of Object.keys(screenConfigRegistry)) {
    const components = getResolvedScreenConfig(screenId);
    let found: SummaryListComponent | null = null;

    walkComponentTree(components, (component) => {
      if (component.componentType === ComponentType.SUMMARY_LIST) {
        const summaryComponent = component as SummaryListComponent;
        if (summaryComponent.SummeryActions?.includes(targetAction)) {
          found = summaryComponent;
          return true;
        }
      }
      return false;
    });

    if (found) {
      return found;
    }
  }

  return null;
};

export const collectFieldNamesForScreen = (screenId: string): Set<string> => {
  const fieldNames = new Set<string>();
  const components = getResolvedScreenConfig(screenId);

  if (!components) {
    return fieldNames;
  }

  walkComponentTree(components, (component) => {
    if (
      inputComponentTypes.includes(component.componentType as ComponentType)
    ) {
      const fieldName = (component as any).name;
      if (fieldName) {
        fieldNames.add(fieldName);
      }
    }
    return false;
  });

  return fieldNames;
};

export const resolveUserCode = (
  decryptedData: Record<string, any> | null | undefined
): string | undefined => {
  if (!decryptedData) {
    return undefined;
  }

  const candidates = [
    decryptedData.usercode,
    decryptedData.empCode,
    decryptedData.userCode,
    decryptedData.empId,
    decryptedData.userId,
    decryptedData.loginName,
    decryptedData.userName,
  ];

  for (const candidate of candidates) {
    if (candidate !== undefined && candidate !== null) {
      const value = String(candidate).trim();
      if (value) {
        return value;
      }
    }
  }

  return undefined;
};

const generateGuid = (): string => {
  const globalCrypto =
    typeof globalThis !== "undefined"
      ? (globalThis.crypto as Crypto | undefined)
      : undefined;

  if (globalCrypto?.randomUUID) {
    return globalCrypto.randomUUID();
  }

  if (globalCrypto?.getRandomValues) {
    const buffer = new Uint8Array(16);
    globalCrypto.getRandomValues(buffer);
    buffer[6] = (buffer[6] & 0x0f) | 0x40;
    buffer[8] = (buffer[8] & 0x3f) | 0x80;
    const hex = Array.from(buffer, (b) => b.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
      .slice(6, 8)
      .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  }

  let timestamp = Date.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (timestamp + Math.random() * 16) % 16 | 0;
    timestamp = Math.floor(timestamp / 16);
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const formatDateForId = (date: Date): string => {
  return `${date.getFullYear().toString().slice(-2)}${String(
    date.getMonth() + 1
  ).padStart(2, "0")}${String(date.getDate()).padStart(2, "0")}${String(
    date.getHours()
  ).padStart(2, "0")}${String(date.getMinutes()).padStart(2, "0")}${String(
    date.getSeconds()
  ).padStart(2, "0")}${String(date.getMilliseconds()).padStart(3, "0")}`;
};

export const generateUniqueFormId = (
  userCode?: string | number,
  instance?: number
): string => {
  const id = generateGuid().replace(/-/g, "");
  const normalizedUserCode = userCode
    ? String(userCode).trim().replace(/\s+/g, "").toUpperCase()
    : "UNKNOWN";
  const timestamp = formatDateForId(new Date());
  const instanceSegment = instance && instance > 0 ? instance : 1;

  return `${id}_${normalizedUserCode}_${timestamp}_${instanceSegment}`;
};

/**
 * Format date from backend format to HTML input format
 * Backend format: "15-01-2024 10:30:00" (DD-MM-YYYY HH:mm:ss)
 * Input format: "2024-01-15T10:30" (YYYY-MM-DDTHH:mm) for datetime-local
 * Or: "2024-01-15" (YYYY-MM-DD) for date input
 * 
 * This matches Blazor's behavior where dates are formatted for input fields
 */
export const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString || typeof dateString !== "string" || dateString.trim() === "") {
    return "";
  }

  try {
    // Backend format: "15-01-2024 10:30:00" (DD-MM-YYYY HH:mm:ss)
    const parts = dateString.trim().split(" ");
    if (parts.length < 1) return "";

    const datePart = parts[0]; // "15-01-2024"
    const timePart = parts[1] || "00:00:00"; // "10:30:00" or default to "00:00:00"

    // Parse date part: DD-MM-YYYY
    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return "";

    // Parse time part: HH:mm:ss
    const [hours, minutes] = timePart.split(":");
    const h = hours || "00";
    const m = minutes || "00";

    // Convert to datetime-local format: YYYY-MM-DDTHH:mm
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
  } catch (error) {

    return "";
  }
};

export const buildFormDataFromRecord = (
  record: Record<string, any> | null | undefined,
  options: {
    fallback?: Record<string, any>;
    summaryComponent?: SummaryListComponent | null;
    screenId?: string;
  } = {}
): Record<string, any> => {
  const { fallback, summaryComponent, screenId } = options;

  const base: Record<string, any> = {
    ...(fallback || {}),
    ...(record || {}),
  };

  const mapped: Record<string, any> = {};

  // Helper function to find value in base with case-insensitive matching
  const findValueInBase = (searchKey: string): any => {
    // Special logging for estimation fields
    const isEstimationField = searchKey === "est_no" || searchKey === "est_date" ||
      searchKey === "txt_estimate_number" || searchKey === "dt_est_date";



    // Try exact match first
    if (base[searchKey] !== undefined && base[searchKey] !== null) {

      return base[searchKey];
    }

    // Try lowercase
    const lowerKey = searchKey.toLowerCase();
    if (base[lowerKey] !== undefined && base[lowerKey] !== null) {

      return base[lowerKey];
    }

    // Try case-insensitive search
    for (const [key, value] of Object.entries(base)) {
      if (
        key.toLowerCase() === lowerKey &&
        value !== undefined &&
        value !== null
      ) {

        return value;
      }
    }



    return undefined;
  };

  // First, copy all base fields directly
  Object.entries(base).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      mapped[key] = value;
    }
  });

  // Then, map fields from summary component if available
  if (summaryComponent?.Form?.Fields) {
    summaryComponent.Form.Fields.forEach((field) => {
      const targetKey = field.BindValue;
      const sourceKey = field.Json_Attribute;

      if (!targetKey || !sourceKey) {
        return;
      }

      // Try to find value using both BindValue and Json_Attribute
      let value = findValueInBase(targetKey);
      if (value === undefined || value === null) {
        value = findValueInBase(sourceKey);
      }

      // Don't skip empty strings - they might be valid values
      if (value !== undefined && value !== null) {
        mapped[targetKey] = value;

      }
    });
  }

  // Finally, map fields from the target screen configuration
  if (screenId) {
    const targetScreenConfig = getResolvedScreenConfig(screenId);
    if (targetScreenConfig) {
      // Walk through the target screen to find all form fields and map data
      walkComponentTree(targetScreenConfig, (component) => {
        // Handle FORM components with childComponents (new format)
        if (component.componentType === LayoutTypes.FORM) {
          const formComponent = component as any;
          // Handle childComponents (new format)
          if (
            formComponent.childComponents &&
            Array.isArray(formComponent.childComponents)
          ) {
            formComponent.childComponents.forEach((field: any) => {
              const fieldName = field.name || field.BindValue;
              const jsonAttr = field.Json_Attribute || field.json_Attribute;

              if (fieldName && jsonAttr) {
                // Try to find value using Json_Attribute from base data
                // This maps API response fields (like "name") to form field names (like "txt_name")
                let value = findValueInBase(fieldName);
                if (value === undefined || value === null) {
                  value = findValueInBase(jsonAttr);
                }

                // Special handling for Proforma Invoice discount:
                // When navigating from Estimate/QC Approve we may already have discount/txt_discount
                // in fallback/formData; if the API response doesn't provide a meaningful value,
                // preserve the existing one instead of overwriting with null/0.
                if (
                  screenId === "175" &&
                  (fieldName === "txt_discount" || jsonAttr === "discount") &&
                  (value === undefined || value === null || value === "" || value === 0 || value === "0")
                ) {
                  const existing =
                    (fallback && (fallback as any).txt_discount) ??
                    (fallback && (fallback as any).discount);
                  if (existing !== undefined && existing !== null && existing !== "") {
                    value = existing;
                  }
                }

                // Special handling for workflow approve_status field (Estimate Approval edit workflow)
                // In some API responses, the workflow state may be exposed under different keys
                // like next_state, Next_State, status, etc. When editing an existing workflow
                // record, we want the approve_status dropdown to pre-populate with the saved state.
                if (
                  (fieldName === "approve_status" || jsonAttr === "approve_status") &&
                  (value === undefined || value === null || value === "")
                ) {
                  const candidateKeys = [
                    "approve_status",
                    "next_state",
                    "Next_State",
                    "nextState",
                    "current_state",
                    "Current_State",
                    "status",
                    "Status",
                  ];

                  for (const key of candidateKeys) {
                    const candidateValue = findValueInBase(key);
                    if (candidateValue !== undefined && candidateValue !== null && candidateValue !== "") {
                      value = candidateValue;
                      break;
                    }
                  }
                }

                // Special handling: For parent_id field in estimation forms, check inspection_id
                if ((value === undefined || value === null) &&
                  (jsonAttr === "parent_id" || fieldName === "parentid")) {

                  // For Estimate Approval (150), prioritize 'id' (Estimate ID)
                  // We do this BEFORE checking inspection_id, because the Estimate record might HAVE an inspection_id,
                  // but for Screen 150 we want the Estimate's own ID as the parent.
                  if (screenId === "150") {
                    value = findValueInBase("id");
                    if (value === undefined || value === null) {
                      value = findValueInBase("estimation_id");
                    }
                  }

                  // Fallback to inspection_id (Standard behavior for Add Estimate screen 116)
                  if (value === undefined || value === null) {
                    value = findValueInBase("inspection_id");
                  }

                  // Generic fallback: If still null, try 'id' (Primary Key of source record)
                  if (value === undefined || value === null) {
                    value = findValueInBase("id");
                  }

                  if (value !== undefined && value !== null) {

                  }
                }

                // Also try snake_case version if jsonAttr is camelCase (API might use date_of_birth)
                if (
                  (value === undefined || value === null) &&
                  !jsonAttr.includes("_")
                ) {
                  // Convert camelCase to snake_case (e.g., dateOfBirth -> date_of_birth)
                  const snakeCaseAttr = jsonAttr
                    .replace(/([A-Z])/g, "_$1")
                    .toLowerCase();
                  value = findValueInBase(snakeCaseAttr);
                }
                // Try camelCase version if jsonAttr is snake_case (API might use dateOfBirth)
                if (
                  (value === undefined || value === null) &&
                  jsonAttr.includes("_")
                ) {
                  // Convert snake_case to camelCase (e.g., date_of_birth -> dateOfBirth)
                  const camelCaseAttr = jsonAttr
                    .split("_")
                    .map((word: string, i: number) =>
                      i === 0
                        ? word
                        : word.charAt(0).toUpperCase() + word.slice(1)
                    )
                    .join("");
                  value = findValueInBase(camelCaseAttr);
                }

                // Map the value to the form field name if found
                // Don't skip empty strings - they might be valid values
                if (value !== undefined && value !== null) {
                  // CRITICAL: Format DATE_FIELD values from backend format to input format
                  // Backend returns: "15-01-2024 10:30:00" (DD-MM-YYYY HH:mm:ss)
                  // Input needs: "2024-01-15T10:30" (YYYY-MM-DDTHH:mm) for datetime-local
                  // This matches Blazor's behavior where dates are formatted for input fields
                  if (field.componentType === ComponentType.DATE_FIELD && typeof value === "string") {
                    const formattedDate = formatDateForInput(value);
                    mapped[fieldName] = formattedDate;
                    if (import.meta.env.DEV) {
                      // console.log(
                      //   `[buildFormDataFromRecord] ✓ Mapped DATE_FIELD ${jsonAttr} -> ${fieldName}:`,
                      //   { original: value, formatted: formattedDate }
                      // );
                    }
                  } else {
                    mapped[fieldName] = value;
                    // So file uploader (FILES) gets value in edit mode from either key
                    if (jsonAttr && jsonAttr !== fieldName) {
                      mapped[jsonAttr] = value;
                    }
                    if (import.meta.env.DEV) {
                      // console.log(
                      //   `[buildFormDataFromRecord] ✓ Mapped ${jsonAttr} -> ${fieldName}:`,
                      //   value
                      // );
                    }
                  }
                } else {
                  // Enhanced logging for missing fields, especially est_no and est_date
                  if (import.meta.env.DEV) {
                    const isEstimationField = jsonAttr === "est_no" || jsonAttr === "est_date" ||
                      fieldName === "txt_estimate_number" || fieldName === "dt_est_date";

                    if (isEstimationField) {
                      // console.warn(
                      //   `[buildFormDataFromRecord] ✗ MISSING Estimation Field: ${fieldName} (Json_Attribute: ${jsonAttr})`,
                      //   {
                      //     fieldName,
                      //     jsonAttr,
                      //     searchedKeys: [
                      //       fieldName,
                      //       jsonAttr,
                      //       jsonAttr.toLowerCase(),
                      //       jsonAttr.toUpperCase(),
                      //       ...(jsonAttr.includes("_") ? [jsonAttr.split("_").map((w: string, i: number) =>
                      //         i === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1)
                      //       ).join("")] : []),
                      //       ...(!jsonAttr.includes("_") ? [jsonAttr.replace(/([A-Z])/g, "_$1").toLowerCase()] : []),
                      //     ],
                      //     availableKeys: Object.keys(base).filter(k =>
                      //       k.toLowerCase().includes("est") ||
                      //       k.toLowerCase().includes("estimate")
                      //     ),
                      //     sampleBaseData: Object.keys(base).slice(0, 30).reduce((acc, k) => {
                      //       acc[k] = base[k];
                      //       return acc;
                      //     }, {} as Record<string, any>),
                      //   }
                      // );
                    } else {
                      // console.log(
                      //   `[buildFormDataFromRecord] Could not find value for ${fieldName} (Json_Attribute: ${jsonAttr})`
                      // );
                    }
                  }
                }
              } else if (fieldName) {
                // Even if no Json_Attribute, try to map by field name directly
                const value = findValueInBase(fieldName);
                if (value !== undefined && value !== null) {
                  mapped[fieldName] = value;
                }
              }
            });
          }

          // Handle FORM components with Fields array (old format)
          const formFields = (component as any).Fields;
          if (formFields && Array.isArray(formFields)) {
            formFields.forEach((field: any) => {
              // Handle nested childComponents (e.g., FIELD_GROUP with childComponents)
              if (
                field.childComponents &&
                Array.isArray(field.childComponents)
              ) {
                field.childComponents.forEach((childField: any) => {
                  const bindValue = childField.BindValue;
                  const jsonAttr = childField.Json_Attribute;
                  if (bindValue && jsonAttr) {
                    // Try to find value using both keys
                    let value = findValueInBase(bindValue);
                    if (value === undefined || value === null) {
                      value = findValueInBase(jsonAttr);
                    }

                    // FORCE OVERRIDE for Screen 150 (Estimate Approval)
                    // We must use the Estimate ID ('id') as the parent, NOT the Inspection ID ('parent_id') 
                    // that might be present in the source record.
                    if (screenId === "150" && (bindValue === "parentid" || jsonAttr === "parent_id")) {
                      const idValue = findValueInBase("id");
                      if (idValue !== undefined && idValue !== null) {
                        value = idValue;
                        if (import.meta.env.DEV) {
                          //  console.log(`[buildFormDataFromRecord] Force-mapped 'id' -> '${bindValue}' for Screen 150:`, value);
                        }
                      }
                    }

                    if (value !== undefined && value !== null && value !== "") {
                      mapped[bindValue] = value;
                      if (import.meta.env.DEV) {
                        // console.log(
                        //   `[buildFormDataFromRecord] Mapped nested field ${jsonAttr} -> ${bindValue}:`,
                        //   value
                        // );
                      }
                    }
                  }
                });
              }

              // Handle direct fields in Fields array (e.g., TEXT_FIELD, DATE_FIELD directly in Fields)
              const bindValue = field.BindValue;
              const jsonAttr = field.Json_Attribute;
              if (bindValue && jsonAttr && field.componentType) {
                // Try to find value using both keys
                let value = findValueInBase(bindValue);
                if (value === undefined || value === null) {
                  value = findValueInBase(jsonAttr);
                }
                // Don't skip empty strings - they might be valid values
                if (value !== undefined && value !== null) {
                  mapped[bindValue] = value;
                  if (import.meta.env.DEV) {
                    // console.log(
                    //   `[buildFormDataFromRecord] Mapped direct field ${jsonAttr} -> ${bindValue}:`,
                    //   value
                    // );
                  }
                } else if (import.meta.env.DEV) {
                  // console.log(
                  //   `[buildFormDataFromRecord] Could not find value for direct field ${bindValue} (Json_Attribute: ${jsonAttr})`
                  // );
                }
              }
            });
          }
        }

        // Handle CUSTOM profileForm components (HRMS Employee Profile Add).
        // These store their fields inside props.tabConfigs -> sections -> fields
        // instead of a standard FORM layout, so we must walk them explicitly.
        if (
          component.componentType === ComponentType.CUSTOM &&
          (component as any).customType === "profileForm"
        ) {
          const tabConfigs = (component as any).props?.tabConfigs;
          if (tabConfigs && typeof tabConfigs === "object") {
            Object.values(tabConfigs).forEach((tabConfig: any) => {
              const sections: any[] = tabConfig?.sections || [];
              sections.forEach((section: any) => {
                const fields: any[] = section?.fields || [];
                fields.forEach((field: any) => {
                  const fieldName = field.name || field.BindValue;
                  const jsonAttr = field.Json_Attribute || field.json_Attribute;
                  if (!fieldName || !jsonAttr) return;

                  // Prefer the BindValue key first, then fall back to Json_Attribute
                  let value = findValueInBase(fieldName);
                  if (value === undefined || value === null) {
                    value = findValueInBase(jsonAttr);
                  }

                  if (value !== undefined && value !== null) {
                    // Store raw value; DateField component handles its own format conversion
                    // (it accepts YYYY-MM-DD, DD-MM-YYYY, DD/MM/YYYY, ISO timestamp, etc.)
                    mapped[fieldName] = value;
                  }
                });
              });
            });
          }
        }

        return false;
      });
    }

    // Also collect field names as before for backward compatibility
    const fieldNames = collectFieldNamesForScreen(screenId);
    fieldNames.forEach((fieldName) => {
      // Try to find value using field name
      let value = findValueInBase(fieldName);

      // If not found, try to find by Json_Attribute
      if ((value === undefined || value === null) && targetScreenConfig) {
        walkComponentTree(targetScreenConfig, (component) => {
          if (component.componentType === LayoutTypes.FORM) {
            const formComponent = component as any;
            if (
              formComponent.childComponents &&
              Array.isArray(formComponent.childComponents)
            ) {
              const field = formComponent.childComponents.find(
                (f: any) => (f.name || f.BindValue) === fieldName
              );
              if (field) {
                const jsonAttr = field.Json_Attribute || field.json_Attribute;
                if (jsonAttr) {
                  value = findValueInBase(jsonAttr);
                  return true; // Stop searching
                }
              }
            }
          }
          return false;
        });
      }

      if (value !== undefined && value !== null) {
        mapped[fieldName] = value;
        if (import.meta.env.DEV) {
          // console.log(
          //   `[buildFormDataFromRecord] Field name mapping: ${fieldName}:`,
          //   value
          // );
        }
      }
    });
  }

  // if (import.meta.env.DEV) {
  //   console.log("[buildFormDataFromRecord] ===== Field Mapping Summary =====");
  //   console.log("[buildFormDataFromRecord] Base data keys:", Object.keys(base || {}));
  //   console.log("[buildFormDataFromRecord] Mapped data keys:", Object.keys(mapped));
  //   console.log("[buildFormDataFromRecord] Mapped fields count:", Object.keys(mapped).length);
  //   console.log("[buildFormDataFromRecord] Sample mapped values:",
  //     Object.keys(mapped).slice(0, 9999).reduce((acc, key) => {
  //       const value = mapped[key];
  //       acc[key] = Array.isArray(value)
  //         ? `[Array(${value.length})]`
  //         : typeof value === 'object' && value !== null
  //           ? '[Object]'
  //           : value;
  //       return acc;
  //     }, {} as Record<string, any>)
  //   );
  //   console.log("[buildFormDataFromRecord] Full mapped data:", mapped);
  //   console.log("[buildFormDataFromRecord] Full base data:", base);
  //   console.log("[buildFormDataFromRecord] ==================================");
  // }

  return mapped;
};

/**
 * Gets parent ID from formData by checking multiple field name variations.
 * Handles common patterns like parentid, parent_id, inspection_id, etc.
 * 
 * @param formData - The form data object to search in
 * @param parentField - The parent field name to look for (e.g., "parentid")
 * @returns The parent ID value if found, null otherwise
 */
export const getParentIdFromFormData = (
  formData: Record<string, any>,
  parentField: string | undefined
): string | number | null => {
  if (!formData) return null;

  // If parentField is provided, try direct match first
  if (parentField && formData[parentField] !== undefined && formData[parentField] !== null && formData[parentField] !== "") {
    return formData[parentField];
  }

  // Common keys for parent IDs in different modules
  const keysToTry = [
    "parentid",
    "parent_id",
    "parentId",
    "inspection_id",
    "inspectionId",
    "jobcard_id",
    "jobcardId",
    "estimate_id",
    "estimateId",
    "id", // Fallback to id if it's the primary record id
  ];

  // If parentField is available, add variations of it
  if (parentField) {
    keysToTry.unshift(
      `${parentField}_id`,
      `${parentField}Id`,
      parentField
    );
  }

  // Try each key case-insensitively
  for (const key of keysToTry) {
    const value = getCaseInsensitiveValue(formData, key);
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  // Final fallback: search all keys for something ending in _id or id
  const idKey = Object.keys(formData).find(k => {
    const kl = k.toLowerCase();
    return kl !== "id" && (kl.endsWith("_id") || kl.endsWith("id")) &&
      !kl.includes("created") && !kl.includes("updated") && !kl.includes("user") && !kl.includes("emp");
  });

  if (idKey && formData[idKey] !== undefined && formData[idKey] !== null && formData[idKey] !== "") {
    return formData[idKey];
  }

  return null;
};

/**
 * Gets parent ID description from formData by checking multiple field name variations.
 */
export const getParentIdDescFromFormData = (
  formData: Record<string, any>,
  parentField: string | undefined
): string => {
  if (!formData) return "";

  const keysToTry = [
    "parent_id_desc",
    "parentid_desc",
    "parentIdDesc",
    "inspection_no",
    "inspectionNo",
    "jobcard_no",
    "jobcardNo",
    "estimate_no",
    "estimateNo",
    "parent_name",
    "parentName",
  ];

  if (parentField) {
    keysToTry.unshift(
      `${parentField}_desc`,
      `${parentField}Desc`,
      `${parentField}_name`,
      `${parentField}Name`
    );
  }

  for (const key of keysToTry) {
    const value = getCaseInsensitiveValue(formData, key);
    if (value !== undefined && value !== null && value !== "") {
      return String(value);
    }
  }

  // Try to find selectedData description
  const selectedData = formData.parentid_selectedData || formData.parent_id_selectedData || (parentField ? formData[`${parentField}_selectedData`] : null);
  if (selectedData && typeof selectedData === 'object') {
    return (selectedData as any).name || (selectedData as any).label || (selectedData as any).estimation_no || (selectedData as any).inspection_no || "";
  }

  return "";
};

export const deriveScreenId = (view: string): string | undefined => {
  if (!view) return undefined;

  // Handle slash-separated paths (e.g., "151/6" or "modulev1/vehiclemake/6")
  const parts = view.split("/");
  const baseView = parts[0];

  if (screenConfigRegistry[view]) {
    return view;
  }

  if (screenConfigRegistry[baseView]) {
    return baseView;
  }

  if (viewToScreenIdMap[view]) {
    return viewToScreenIdMap[view];
  }

  if (viewToScreenIdMap[baseView]) {
    return viewToScreenIdMap[baseView];
  }

  // Handle full URLs dynamically by checking if valid map keys are contained in the view string
  // This allows matching URLs like ".../screen/vehiclemake" to "screen/vehiclemake" without hardcoding domains
  const dynamicMatch = Object.keys(viewToScreenIdMap).find(
    (key) => key.includes("/") && view.endsWith(key)
  );
  if (dynamicMatch) {
    return viewToScreenIdMap[dynamicMatch];
  }

  // Also check if any part of the path matches a screen ID
  for (const part of parts) {
    if (screenConfigRegistry[part]) {
      return part;
    }
  }

  return undefined;
};

/**
 * For job card add view (e.g. modulev1/jobcard_add/{id}), returns the id segment
 * so SubModule/Report and App can use it as parentid (estimation id).
 */
export const getRecordIdFromView = (view: string): string | null => {
  if (!view || typeof view !== "string") return null;
  const parts = view.split("/").filter(Boolean);
  if (!view.includes("jobcard_add") || parts.length < 2) return null;
  const last = parts[parts.length - 1];
  if (!last || last === "jobcard_add" || last.includes("<") || last.includes(">")) return null;
  return last;
};

const getCaseInsensitiveValue = (
  source: Record<string, any> | null | undefined,
  targetKey: string
) => {
  if (!source || typeof source !== "object") {
    return undefined;
  }

  const normalizedTarget = targetKey.toLowerCase();

  for (const [key, value] of Object.entries(source)) {
    if (key.toLowerCase() === normalizedTarget) {
      return value;
    }
  }

  return undefined;
};

const extractNavigatePlaceholders = (navigatePath?: string): string[] => {
  if (!navigatePath || typeof navigatePath !== "string") {
    return [];
  }

  const keys: string[] = [];

  const placeholderRegex = /<([^>]+)>/g;
  let match: RegExpExecArray | null;

  while ((match = placeholderRegex.exec(navigatePath)) !== null) {
    const rawKey = match[1]?.trim();
    if (rawKey) {
      keys.push(rawKey);
    }
  }

  return keys;
};

const shouldIgnoreIdKey = (key: string) => {
  const lower = key.toLowerCase();
  return (
    lower.includes("customer") ||
    lower.includes("created") ||
    lower.includes("updated") ||
    lower.includes("deleted")
  );
};

export const deriveRecordIdFromRow = (
  row: Record<string, any> | null | undefined,
  options: { summaryAction?: SummaryListActionConfig } = {}
): string | number | undefined => {
  if (!row || typeof row !== "object") {
    return undefined;
  }

  const keysToCheck: string[] = [];
  const seen = new Set<string>();

  const enqueueKey = (key?: string | null) => {
    if (!key) {
      return;
    }
    const trimmed = key.trim();
    if (!trimmed) {
      return;
    }
    const lower = trimmed.toLowerCase();
    if (seen.has(lower)) {
      return;
    }
    seen.add(lower);
    keysToCheck.push(trimmed);
  };

  // CRITICAL: Check for __workflowChildId first (passed from DataTable for workflow actions)
  enqueueKey("__workflowChildId");

  const navigatePath =
    options.summaryAction?.Action?.Navigate ||
    options.summaryAction?.Action?.navigate;
  extractNavigatePlaceholders(navigatePath).forEach(enqueueKey);

  enqueueKey(
    options.summaryAction?.Action?.RecordIdKey ||
    options.summaryAction?.Action?.recordIdKey ||
    options.summaryAction?.Action?.RecordID ||
    options.summaryAction?.Action?.recordID
  );

  const idLikeKeys = Object.keys(row).filter((key) => {
    const lower = key.toLowerCase();
    if (shouldIgnoreIdKey(lower)) {
      return false;
    }
    return lower === "id" || lower.endsWith("_id") || lower.endsWith("id");
  });

  const keyWeight = (key: string) => {
    const lower = key.toLowerCase();
    if (lower === "id") return 0;
    if (lower.endsWith("_id")) return 1;
    if (lower.endsWith("id")) return 2;
    return 3;
  };

  idLikeKeys
    .sort((a, b) => keyWeight(a) - keyWeight(b))
    .forEach((key) => enqueueKey(key));

  for (const key of keysToCheck) {
    const value = getCaseInsensitiveValue(row, key);
    if (value !== undefined && value !== null && value !== "") {
      return value as string | number;
    }
  }

  return undefined;
};

export const extractDrawerMenu = (): DrawerMenuConfig | undefined => {
  const screenGroup = screen_100_home[0] as ScreenGroupComponent;
  return screenGroup.drawerMenu;
};

export const resolveView = (view: string) => view;

export const loadEncryptedUserData = () =>
  localStorage.getItem("encryptedUserData");

export const decryptUserData = (encrypted: string) =>
  authService.decryptData(encrypted);

export const fetchScreenData = (screenId: string) =>
  apiService.get(
    "/pabws/screens/get_screens_with_id",
    { screenid: screenId },
    {
      errorHandling: "throw",
      transformResponse: (data: any) => {
        if (data) {
          if (data.data) {
            return Array.isArray(data.data) ? data.data[0] : data.data;
          } else if (Array.isArray(data)) {
            return data[0];
          }
          return data;
        }
        return null;
      },
    }
  );
